var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-bar-chart"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-spinner"})]):_c('div',{staticClass:"container-chart"},[_c('BarChartV2',{attrs:{"data":_vm.data,"labels":_vm.labels,"title":_vm.title,"data_line":_vm.data_line,"labels_line":_vm.labels_line}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }